__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "@cts/mularis-frontend";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@cts/cts-components", "0.1.0-3202", () => (Promise.all([__webpack_require__.e("vendors-node_modules_cts_cts-components_dist_cts-components_es_js"), __webpack_require__.e("vendors-node_modules_lodash_lodash_js-node_modules_quasar_dist_quasar_client_js"), __webpack_require__.e("webpack_sharing_consume_default_vue_vue-webpack_sharing_consume_default_vue_vue")]).then(() => (() => (__webpack_require__(/*! ./node_modules/@cts/cts-components/dist/cts-components.es.js */ "./node_modules/@cts/cts-components/dist/cts-components.es.js"))))));
			register("vue-router", "4.2.4", () => (Promise.all([__webpack_require__.e("vendors-node_modules_vue-router_dist_vue-router_mjs"), __webpack_require__.e("webpack_sharing_consume_default_vue_vue-_06aa"), __webpack_require__.e("node_modules_vue_devtools-api_lib_esm_index_js-_3f4e0")]).then(() => (() => (__webpack_require__(/*! ./node_modules/vue-router/dist/vue-router.mjs */ "./node_modules/vue-router/dist/vue-router.mjs"))))));
			register("vue", "3.5.44", () => (__webpack_require__.e("vendors-node_modules_vue_runtime-dom_dist_runtime-dom_esm-bundler_js").then(() => (() => (__webpack_require__(/*! ./node_modules/@vue/runtime-dom/dist/runtime-dom.esm-bundler.js */ "./node_modules/@vue/runtime-dom/dist/runtime-dom.esm-bundler.js"))))));
			register("vuex", "4.0.2", () => (Promise.all([__webpack_require__.e("vendors-node_modules_vuex_dist_vuex_esm-bundler_js"), __webpack_require__.e("webpack_sharing_consume_default_vue_vue-_587c"), __webpack_require__.e("node_modules_vue_devtools-api_lib_esm_index_js-_3f4e1")]).then(() => (() => (__webpack_require__(/*! ./node_modules/vuex/dist/vuex.esm-bundler.js */ "./node_modules/vuex/dist/vuex.esm-bundler.js"))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};